<script>
export default {
  props: {
    size: {
      type: String,
      default: '32'
    },
    player: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <figure
    class="image is-cover is-round"
    :class="'is-' + size + 'x' + size"
    v-if="player.picture_path">
    <img :src="player.picture_path" :alt="player.name"/>
  </figure>
  <div class="caption image is-round"
    :class="'is-' + size + 'x' + size"
    v-else>
    {{ player.initials }}
  </div>
</template>

<style lang="scss" scoped>
  .caption {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    color: $grey-darker;
    background: #A9E2FB;
  }
</style>



// WEBPACK FOOTER //
// PlayerAvatar.vue?b884ee9e